<template>
  <BaseWarning>
    <i18n path="warnings.unsuitableInstruction.warning" tag="span">
      <template #instruction>{{ $t(`tactics.instructions.${data.instruction}`) }}</template>
      <template #suitability>{{ data.suitability.toFixed(1) }}</template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";

export default {  
  props: {
    data: Object
  },

  components: { BaseWarning },
};
</script>
